export default __webpack_public_path__ + "static/empower-561ed3ea518d25d363f98003cd5dc8bd.svg";